



















































































import Vue from "vue";
import { SearchResponseDocument } from "search-api-client/lib/models";
export default Vue.extend({
  name: "ResultProject",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: []
    }
  },
  methods: {
    getCustomProperty(propertyName) {
      const customProperty = this.result.customProperties.find(
        (x) => x.key === propertyName
      );
      if (customProperty) {
        return customProperty.value;
      } else {
        return "";
      }
    }
  }
});
